"use client";

import LoginForm from "@/components/customer/account/login/login-form";
import Loading from "@/app/loading";
import { Suspense, useEffect } from "react";
import { sessionStorageCleanup } from "@/utils/helper";

import { useAuthContext } from "@/context/auth-context";
import { useRouter } from "next/navigation";

export default function Login() {
  const { isLoggedIn } = useAuthContext();
  const router = useRouter();
  useEffect(() => {
    if(isLoggedIn){
      router.replace("/");
    }else{
      sessionStorageCleanup();
    }
  }, []);
  return (
    <Suspense fallback={<Loading />}>
      <LoginForm />
    </Suspense>
  );
}
